import {
  useState, useCallback, useEffect, useContext
} from 'react';

import {
  getManagementNursingHolidayStatus,
  downloadNursingCareHolidayStatusCSV
} from 'api/holidayManagement';
import ManagementNursingHolidayStatusDomain from 'domain/master/holidayManagement/managementNursingHolidayStatus';
import useToastNotification from 'hooks/useToastNotification';
import { HolidayManagementContext } from './../../HolidayManagementForm'

export const useManagementInformationDomainForm = () => {
  const sessionStorageOrgCode = sessionStorage.getItem('loginUser.orgCode') || '';
  const [orgCode, setOrgCode] = useState(sessionStorageOrgCode);
  const [employmentId, setOrgEmploymentId] = useState('');
  const [extinctionDaysStart, setExtinctionDaysStart] = useState('');
  const [extinctionDaysEnd, setExtinctionDaysEnd] = useState('');
  const [targetGrantTenDays, setTargetGrantTenDays] = useState(false);
  const [untilNextGrantDate, setUntilNextGrantDate] = useState('');
  const [managementNursingHolidayStatus, setManagementNursingHolidayStatus] = useState<ManagementNursingHolidayStatusDomain[]>([])

  const [holidayType, setHolidayType] = useState('7');
  const holidayOptions = [
    {
      value : '7',
      label: '介護休暇'
    },
    {
      value : '8',
      label: '子の看護休暇'
    }
  ];

  const [modalOpen, setModalOpen] = useState(false);

  const contextObject = useContext(HolidayManagementContext);

  // データの取得
  const fetchData = useCallback(async () => {
    contextObject.setIsLoading(true);
    await getManagementNursingHolidayStatus(
      holidayType,
      orgCode !== 'all' ? orgCode : '',
    ).then((response: any) => {
      setManagementNursingHolidayStatus(response);
    });
    contextObject.setIsLoading(false);
  }, [
    orgCode, holidayType
  ]);

  useEffect(() => {
    fetchData();
  }, [fetchData, orgCode, holidayType]);

  return {
    orgCode,
    setOrgCode,
    employmentId,
    setOrgEmploymentId,
    extinctionDaysStart,
    setExtinctionDaysStart,
    extinctionDaysEnd,
    setExtinctionDaysEnd,
    targetGrantTenDays,
    setTargetGrantTenDays,
    modalOpen,
    setModalOpen,
    setUntilNextGrantDate,
    untilNextGrantDate,
    holidayType,
    setHolidayType,
    holidayOptions,
    managementNursingHolidayStatus
  };
};

export const useDownloadHolidayManagement = (
  orgCode: string,
  holidayType: string
) => {
  const [blocking, setBlocking] = useState(false);
  const downloadNursingCareHolidayStatus = useCallback(() => {
    setBlocking(true);
    downloadNursingCareHolidayStatusCSV(
      Number(holidayType),
      orgCode !== 'all' ? orgCode : '',
    ).then((response) => {
      setBlocking(false);
    });
  }, [orgCode, holidayType]);

  return {
    downloadNursingCareHolidayStatus,
    blocking
  };
};

export default {
  useManagementInformationDomainForm,
};
